import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";

const benefits = [
  {
    title: "Data-Driven Insights",
    description:
      "Understand your credit profile and identify areas for improvement.",
    image: "/businessBanner1.png", // Replace with actual image URL
  },
  {
    title: "Tailored Recommendations",
    description:
      "Find the financing solutions that best match your needs and goals.",
    image: "/businessBanner2.png",
  },
  {
    title: "Streamlined Process",
    description: "Get funding offer before you apply for loan. Save Time and effort.",
    image: "/businessBanner3.png",
  },
  {
    title: "Access to Capital",
    description: "Connect only with relevant lenders, choose the best funding options.",
    image: "/businessBanner4.png",
  },
];


const BusinessBenefits = () => {
  return (
    <>
      {/* Centered Line & Title */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          marginTop:"2%"
        }}
      >
        <Box
          sx={{ width: "40px", height: "2px", backgroundColor: "#004AAD" }}
        />
        <Typography variant="h8" sx={{ fontWeight: "bold", color: "#004AAD" }}>
          Why Choose Dequitec?
        </Typography>
      </Box>
      <Box textAlign="center" marginTop={1}>
        {/* Subtitle */}
        <Typography
          variant="h6"
          sx={{
            mt: 1,
            mb: 2,
            fontWeight: "bold",
            color: "#333333",
            textAlign: "center",
          }}
        >
          Benefits for Your Business
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 5,
          p: 3,
          mx: {xs:1,sm:1,md:5,lg:5},
        }}
      >
        {benefits.map((benefit, index) => (
          <Card
            key={index}
            sx={{
              backgroundColor: "#F4EFFF",
              width: { xs: "100%", sm: 250 },
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              boxShadow: 3,
              p: 2,
            }}
          >
            <img
              src={benefit.image}
              alt={benefit.title}
              style={{  height: 180, marginBottom: 16 }}
            />
            <CardContent>
              <Typography variant="h7" sx={{ fontWeight: "bold"}}>
                {benefit.title}
              </Typography>
              <Typography
                variant="body2"
                marginTop={2}
                sx={{ fontStyle: "italic", color: "gray" }}
              >
                {benefit.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </>
  );
};

export default BusinessBenefits;
